<template>
  <div :id="'chart_'+uuid">
    <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
      <canvas :id="uuid" :width="size.width" :height="size.height" />
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: "43e8445a-e34a-11ed-8761-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      system: [],
      count: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.system,
            datasets: [{
              //label: this.chart.report_description,
              data: this.count,
              maxBarThickness: 800
            }]
          },
          options: {
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Количество обращений'
                },
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              },
              legend: {
                display: false
              },
            }
          }
        })
      }
    },
    update_data: function () {
      this.system = []
      this.count = []
      for (let i =0; i < this.chart.report_data.length; i++) {
        this.system.push(this.chart.report_data[i]["ВидСервисаПРЕДСТАВЛЕНИЕ"])
        this.count.push(this.chart.report_data[i]["Неисправности"])
      }
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    }
  }
}
</script>

<style scoped>

</style>